import React, { useMemo } from "react";
import { ShippingCaseResponse } from "@pages/shippingView/types";
import {
  Outlet,
  useOutletContext,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";

export default function TMSLayoutWrapper() {
  const { shipping } = useOutletContext<{ shipping: ShippingCaseResponse }>();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = useMemo(
    () => [
      {
        label: "Loading Order List",
        value: "loading-orders",
      },
      {
        label: "Loading Order List (WHS)",
        value: "whs-loading-orders",
      },
    ],
    [],
  );

  const currentPath = location.pathname.split("/").slice(-1)[0];
  const activeTab = useMemo(() => {
    if (location.pathname.includes("whs-loading-orders")) {
      return "whs-loading-orders";
    }
    if (
      location.pathname.includes("loading-order") ||
      /^\d+$/.test(currentPath)
    ) {
      return "loading-orders";
    }
    return currentPath;
  }, [location.pathname, currentPath]);

  return (
    <React.Suspense key={shipping?.id} fallback={null}>
      <Box>
        <Tabs
          variant="scrollable"
          value={activeTab}
          onChange={(_, newValue) => navigate(newValue)}
          sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>

        <Box sx={{ pt: 2 }}>
          <Outlet context={{ shipping }} />
        </Box>
      </Box>
    </React.Suspense>
  );
}
